import React from 'react';
import './Card.css';

/**
 * Flexible card component that supports multiple game types
 */
const Card = ({ card, isRemoving = false, size = 'normal', mini = false }) => {
  const gameType = card.gameType || 'billiards';
  
  // Billiards cards
  if (gameType === 'billiards') {
    const isStripe = card.isStripe || card.number >= 9;
    return (
      <div 
        className={`ball ${size} ${mini ? 'mini' : ''} ${isStripe ? 'stripe' : 'solid'} ${isRemoving ? 'ball-removing' : ''}`}
        style={{ '--ball-color': card.color }}
      >
        <div className="ball-number">
          {card.number}
        </div>
      </div>
    );
  }
  
  // Uno cards
  if (gameType === 'uno') {
    return (
      <div 
        className={`card uno-card ${size} ${mini ? 'mini' : ''} ${isRemoving ? 'card-removing' : ''}`}
        style={{ '--card-color': card.color }}
      >
        <div className="card-content">
          {card.action ? (
            <span className="card-action">{card.action.replace('_', ' ')}</span>
          ) : (
            <span className="card-number">{card.number}</span>
          )}
        </div>
      </div>
    );
  }
  
  // Playing cards
  if (gameType === 'playingCards') {
    const suitSymbols = {
      hearts: '♥',
      diamonds: '♦',
      clubs: '♣',
      spades: '♠'
    };
    return (
      <div 
        className={`card standard-card ${size} ${mini ? 'mini' : ''} ${isRemoving ? 'card-removing' : ''}`}
        style={{ '--card-color': card.color }}
      >
        <div className="card-content">
          <span className="card-rank">{card.rank}</span>
          <span className="card-suit">{suitSymbols[card.suit]}</span>
        </div>
      </div>
    );
  }
  
  // Exploding Kittens cards
  if (gameType === 'explodingKittens') {
    return (
      <div 
        className={`card kitten-card ${size} ${mini ? 'mini' : ''} ${isRemoving ? 'card-removing' : ''} ${card.type === 'exploding_kitten' ? 'exploding-kitten' : ''}`}
        style={{ '--card-color': card.color }}
      >
        <div className="card-content">
          {card.emoji && <span className="card-emoji">{card.emoji}</span>}
          {card.name && <span className="card-name">{card.name}</span>}
          {card.number !== undefined && !card.name && (
            <span className="card-number">{card.number}</span>
          )}
        </div>
      </div>
    );
  }
  
  // Default number cards
  return (
    <div 
      className={`card number-card ${size} ${mini ? 'mini' : ''} ${isRemoving ? 'card-removing' : ''}`}
      style={{ '--card-color': card.color }}
    >
      <div className="card-content">
        <span className="card-number">{card.number}</span>
      </div>
    </div>
  );
};

export default Card;


